<template>
  <div>
    <div class="text-left">
      <v-bottom-sheet v-model="sheet">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="blue"
              dark
              v-bind="attrs"
              v-on="on"
          >
            Show Payments calculations
          </v-btn>
        </template>
        <v-sheet
            class="text-center"
            height="500px"
        >
          <v-btn
              class="mt-6"
              text
              color="red"
              @click="sheet = !sheet"
          >
            close
          </v-btn>
          <div class="text-left" style="margin-left: 7px;">

            <label>
              All Payments {{currentStatus}}
            </label>

          </div>
          <div>
            <template>
            <v-simple-table>

              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Payment Type
                  </th>
                  <th  class="text-right">
                    Payment Amount
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="item in paymentsCalculations.data"
                    :key="item.paymentType"
                >
                  <td class="text-left">

                    <vue-json-to-csv v-if="item.paymentType === 'PayPal' || item.paymentType === 'WireTransfer'"
                        :json-data="paymentDetailsByMethod(item.details, item.paymentType)"
                        :csv-title="item.paymentType + '_' + currentStatus"
                        :labels="{
                          id: { title: 'Idap' },
                          amount: { title: 'Amount' },
                          abbr: { title: 'SubmittedAmountCurrency' },
                          refCode: { title: 'RefCode' },
                          eWalletMessage: { title: 'EWalletMessage' },
                          bankingMessage: { title: 'BankingMessage' },
                          ignoreThresholds: { title: 'IgnoreThresholds' },
                          emailMessage: { title: 'EmailMessage' },
                          scheduledDate: { title: 'ScheduledDate' },
                          visibleWhenScheduled: { title: 'VisibleWhenScheduled' }
                        }"
                        @success="val => csvUploaderHandleSuccess(val)"
                        @error="val => csvUploaderHandleError(val)">
                      <button style="color: blue;cursor: pointer;"> {{ item.paymentType }}</button>
                    </vue-json-to-csv>

                    <vue-json-to-csv v-else-if="item.paymentType === 'Bitcoin'"
                       :json-data="paymentDetailsByMethod(item.details, item.paymentType)"
                       :csv-title="item.paymentType + '_' + currentStatus"
                       :labels="{
                          id: { title: 'Affiliate ID' },
                          email: { title: 'Emails' },
                          amount: { title: 'Amount' },
                          abbr: { title: 'Currency' },
                          bitcoinWallet: { title: 'Bitcoin Wallet' },
                        }"
                       @success="val => csvUploaderHandleSuccess(val)"
                       @error="val => csvUploaderHandleError(val)">
                      <button style="color: blue;cursor: pointer;"> {{ item.paymentType }}</button>
                    </vue-json-to-csv>
                      <vue-json-to-csv v-else-if="item.paymentType === 'Payoneer' "
                         :json-data="paymentDetailsByMethod(item.details, item.paymentType)"
                         :csv-title="item.paymentType + '_' + currentStatus"
                         :labels="{
                            payoneerEmail: { title: 'Recipient Email' },
                            abbr: { title: 'Payoneer Balance to Pay From' },
                            amount: { title: 'Amount' },
                            transactionDescription: { title: 'Transaction Description' }
                        }"
                         @success="val => csvUploaderHandleSuccess(val)"
                         @error="val => csvUploaderHandleError(val)">
                        <button style="color: blue;cursor: pointer;"> {{ item.paymentType }}</button>
                      </vue-json-to-csv>

                      <vue-json-to-csv v-else
                         :json-data="paymentDetailsByMethod(item.details, item.paymentType)"
                         :csv-title="item.paymentType + '_' + currentStatus"
                         :labels="{
                            id: { title: 'Affiliate ID' },
                            email: { title: 'Emails' },
                            amount: { title: 'Amount' },
                            abbr: { title: 'Currency' },
                          }"
                         @success="val => csvUploaderHandleSuccess(val)"
                         @error="val => csvUploaderHandleError(val)">
                      <button style="color: blue;cursor: pointer;"> {{ item.paymentType }}</button>
                    </vue-json-to-csv>
                  </td>

                  <td class="text-right">{{ item.paymentAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') }}</td>

                </tr>
                </tbody>
                <tr>

                </tr>

                <br>
                <tbody>
                <tr>
                  <td class="text-left" style="font-weight: bold; color: #000000;" >Total</td>
                  <td class="text-right">
                    <span style="font-weight: bold; color: #000000; margin-left: 15px;">
                       {{ paymentsCalculations.total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') }}
                    </span>
                  </td>
                </tr>
                </tbody>

                <tbody>
                <tr>
                  <td class="text-left">
                    <vue-json-to-csv
                        :json-data="paymentDetailsTipalti(paymentsCalculations.data)"
                        :csv-title="'tipalti_' + currentStatus"
                        :labels="{
                          id: { title: 'Idap' },
                          amount: { title: 'Amount' },
                          abbr: { title: 'SubmittedAmountCurrency' },
                          refCode: { title: 'RefCode' },
                          eWalletMessage: { title: 'EWalletMessage' },
                          bankingMessage: { title: 'BankingMessage' },
                          ignoreThresholds: { title: 'IgnoreThresholds' },
                          emailMessage: { title: 'EmailMessage' },
                          scheduledDate: { title: 'ScheduledDate' },
                          visibleWhenScheduled: { title: 'VisibleWhenScheduled' },
                          // paymentType: { title: 'paymentType' }
                        }"
                        @success="val => csvUploaderHandleSuccess(val)"
                        @error="val => csvUploaderHandleError(val)">
                      <button
                          ref="tipaltiButton"
                          style="visibility: hidden;"
                      > </button>

                    </vue-json-to-csv>
                    <label
                        style="
                        color: blue;
                        cursor: pointer;
                        padding-left: 5px;
                        margin-top: 15px;
                        float: left;
                      " @click="createCSVTipalti">Tipalti
                    </label>

                  </td>

                  <td class="text-right">
                  <span style="font-weight: bold; color: #000000; margin-left: 15px;">
                      {{ tipaltiAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') }}
                  </span>
                  </td>
                </tr>

                <tr>
                  <td class="text-left">
                    <vue-json-to-csv
                        :json-data="paymentDetailsByType(paymentsCalculations.data,'Payoneer')"
                        :csv-title="'payoneer_' + currentStatus"
                        :labels="{
                            id: { title: 'Payee id' },
                            amount: { title: 'Amount' },
                            abbr: { title: 'Currency' },
                            paymentId: { title: 'Internal payment id' },
                            description: { title: 'Description' },
                            paymentDate: { title: 'Payment date' },
                            groupId: { title: 'Group id' },
                        }"
                        @success="val => csvUploaderHandleSuccess(val)"
                        @error="val => csvUploaderHandleError(val)">
                      <button
                          ref="payoneerButton"
                          style="visibility: hidden;"
                      > </button>

                    </vue-json-to-csv>

                    <vue-json-to-csv
                        :json-data="paymentDetailsByType(paymentsCalculations.data,'Bitcoin')"
                        :csv-title="'bitcoin_' + currentStatus"
                        :labels="{
                      id: { title: 'Affiliate ID' },
                      email: { title: 'Emails' },
                      amount: { title: 'Amount' },
                      abbr: { title: 'Currency' },
                      bitcoinWallet: { title: 'Bitcoin Wallet' },
                    }"
                        @success="val => csvUploaderHandleSuccess(val)"
                        @error="val => csvUploaderHandleError(val)">
                      <button
                          ref="bitcoinButton"
                          style="visibility: hidden;"
                      > </button>

                    </vue-json-to-csv>
                    <label
                        style="
                        color: blue;
                        cursor: pointer;
                        padding-left: 10px;
                        margin-top: 15px;
                        float: left;
                        clear: both;
                      " @click="createCSVRest">Rest
                    </label>
                  </td>
                  <td class="text-right">
                  <span style="font-weight: bold; color: #000000; margin-left: 5px;">
                      {{ restSumAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') }}
                  </span>
                  </td>
                </tr>
                </tbody>

              </template>
            </v-simple-table>
            </template>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <v-row justify="end">
      <v-col cols="12" lg="auto" class="mb-0 pb-0">
        <div v-if="currentTab === 'pending'">
          <v-btn @click="massAction('approve')" color="primary" class="mr-2" :disabled="isMassBtnDisabled">
            Mass Approve
          </v-btn>
          <v-btn @click="massAction('carry_over')" color="secondary" class="mr-2" :disabled="isMassBtnDisabled || isLoading">
            Mass Carry Over
          </v-btn>
          <v-btn @click="exportPayments()" color="info" class="mr-2" :disabled="isMassBtnDisabled">
            <v-icon class="mr-2">mdi-export</v-icon>
            Export Payments
          </v-btn>
        </div>
        <div v-if="currentTab === 'approved'">
          <v-btn @click="uploadCSV()" color="success" class="mr-2" :disabled="false">
            <v-icon class="mr-2">mdi-upload</v-icon>
            Upload CSV
          </v-btn>
          <v-btn @click="massAction('download')" color="success" class="mr-2" :disabled="isMassBtnDisabled">
            <v-icon v-if="!isDownloading" class="mr-2">mdi-download</v-icon>
            <v-progress-circular v-else indeterminate :size="20" color="white"></v-progress-circular>
            Mass Download
          </v-btn>
          <v-btn @click="massAction('pay')" color="primary" class="mr-2" :disabled="isMassBtnDisabled">
            Mass Payment
          </v-btn>
          <v-btn @click="massAction('carry_over')" color="secondary" class="mr-2" :disabled="isMassBtnDisabled">
            Mass Carry Over
          </v-btn>
          <v-btn @click="massAction('close')" color="error" class="mr-2" :disabled="isMassBtnDisabled">
            Mass Rejection
          </v-btn>
          <v-btn @click="exportPayments()" color="info" class="mr-2" :disabled="isMassBtnDisabled">
            <v-icon class="mr-2">mdi-export</v-icon>
            Export Payments
          </v-btn>
        </div>
        <div v-if="currentTab === 'closed'">
          <v-btn @click="massAction('download')" color="success" class="mr-2" :disabled="isMassBtnDisabled">
            <v-icon v-if="!isDownloading" class="mr-2">mdi-download</v-icon>
            <v-progress-circular v-else indeterminate :size="20" color="white"></v-progress-circular>
            Mass Download
          </v-btn>
          <v-btn @click="exportPayments()" color="info" class="mr-2" :disabled="isMassBtnDisabled">
            <v-icon class="mr-2">mdi-export</v-icon>
            Export Payments
          </v-btn>
        </div>
        <div v-if="currentTab === 'active'">
          <v-btn @click="exportPayments()" color="info" class="mr-2" :disabled="isMassBtnDisabled">
            <v-icon class="mr-2">mdi-export</v-icon>
            Export Payments
          </v-btn>
        </div>
        <div v-if="currentTab === 'carried_over'">
          <v-btn @click="exportPayments()" color="info" class="mr-2" :disabled="isMassBtnDisabled">
            <v-icon class="mr-2">mdi-export</v-icon>
            Export Payments
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row justify="start" align="center">
      <v-col cols="12" lg="auto"><h1 class="mb-0">Payments</h1></v-col>
      <v-col cols="12" lg="auto">
        <v-tabs color="primary" v-model="byStatus">
          <v-tab to="/payments/active" key="/payments/active">Active</v-tab>
          <v-tab to="/payments/pending" key="/payments/pending">Pending</v-tab>
          <v-tab to="/payments/approved" key="/payments/approved">Approved</v-tab>
          <v-tab to="/payments/closed" key="/payments/closed">Paid</v-tab>
          <v-tab to="/payments/carried-over" key="/payments/carried-over">Carried Over</v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-data-table
        :headers="table.headers"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :items="payments.data"
        :server-items-length="payments.count"
        :disable-sort="true"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :page="table.currentPage"
        :items-per-page="table.perPage"
        :expanded.sync="expanded"
        show-expand
        :single-expand="false"
        loading-text="Loading... Please wait"
        fixed-header
        :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
        item-class="td_title"
        color="#7F98A5"
        @pagination="updateTablePagination"
        :show-select="isShowSelect"
        v-model="selectedRows"
        @input="onSelect"
        @item-expanded="itemExpandedHandler"
    >
      <template v-slot:top>
        <DataTableTopBar @search="search"></DataTableTopBar>
      </template>
      <template v-slot:header.data-table-select="{ props }">
        <div style="display: flex; align-items: center;">
          <v-checkbox
                  :indeterminate="props.indeterminate"
                  :input-value="allSelected"
                  @click="toggleSelectAll"
                  primary
          />
          <span style="position: absolute; margin-left:-40px;color: var(--v-primary-base)">{{ selectedRows.length }}</span>
        </div>
      </template>
      <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <data-filter type="items"
                     v-if="table.filters.hasOwnProperty(header.value)"
                     :type="item.value === 'amount'? 'range' : 'items'"
                     :min="item.value === 'amount' && table.filters[header.value].data[0] ? Number(table.filters[header.value].data[0].key): 0"
                     :max="item.value === 'amount' && table.filters[header.value].data[0] ? Number(table.filters[header.value].data[0].value): 0"
                     :items="table.filters[header.value].data"
                     :entity="header.value"
                     :values="table.filters[header.value].selected"
                     @apply="submitFilter"
                     @search="updateDataInFilters"
        ></data-filter>
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}</v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>
      <!-- header -->
      <!-- body -->
      <template v-for="header of table.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
        <template v-if="header.value === 'actions'">
          <template v-if="item.status === 'active'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="editHandler(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="error" @click="reviewHandler(item)">
                  <v-icon>mdi-eye-check</v-icon>
                </v-btn>
              </template>
              <span>Risk Review</span>
            </v-tooltip>
          </template>
          <template v-if="item.status === 'pending'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="editHandler(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="carryOverHandler(item)">
                  <v-icon>mdi-autorenew</v-icon>
                </v-btn>
              </template>
              <span>Carry Over</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="success" @click="approveHandler(item)">
                  <v-icon>mdi-check-decagram</v-icon>
                </v-btn>
              </template>
              <span>Approve</span>
            </v-tooltip>
          </template>
          <template v-if="item.status === 'approved'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="editHandler(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="carryOverHandler(item)">
                  <v-icon>mdi-autorenew</v-icon>
                </v-btn>
              </template>
              <span>Carry Over</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="success" @click="paidHandler(item)">
                  <v-icon>fa-handshake</v-icon>
                </v-btn>
              </template>
              <span>Mark as paid</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :loading="!!invoiceLoading[item.id]" icon color="secondary" @click="invoiceHandler(item)">
                  <v-icon>fa-file-invoice</v-icon>
                </v-btn>
              </template>
              <span>Invoice</span>
            </v-tooltip>
          </template>
          <template v-if="item.status === 'closed'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="editHandler(item)">
                  <v-icon>mdi-eye-outline</v-icon>
                </v-btn>
              </template>
              <span>View</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="invoiceHandler(item)">
                  <v-icon>fa-file-invoice</v-icon>
                </v-btn>
              </template>
              <span>Invoice</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="undoHandler(item)">
                  <v-icon>mdi-undo-variant</v-icon>
                </v-btn>
              </template>
              <span>Revert to approved</span>
            </v-tooltip>
          </template>
        </template>
        <template v-if="header.value === 'currency'">
          <v-tooltip top open-delay="400">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{item.currencySymbol}}</span>
            </template>
            <span>{{item.currencyName}}</span>
          </v-tooltip>
        </template>
        <template v-if="header.value === 'period'">
          {{ getPeriod(item.start_period, item.end_period) }}
        </template>
        <template v-else-if="header.value === 'dateAdded'">
          {{getPrettyDate(item.dateAdded)}}
        </template>
        <template v-else-if="header.value === 'payment_type'">
          <v-btn v-if="item.paymentType" color="secondary" text @click="expandItem(item, 'details')">
            {{item.paymentType}}
          </v-btn>
        </template>
        <template v-else-if="header.value === 'payment_terms'">
          {{item.paymentTerm}}
        </template>
        <template v-else-if="header.value === 'amount'">
          {{(item.amount + item.referral_commission + item.carry_over_referral_commission).toFixed(2)}}
        </template>
        <template v-else-if="header.value === 'affiliate_name'">
          {{item.affiliateName}}
        </template>
        <template v-else-if="header.value === 'affiliate_status'">
          {{item.affiliate_status}}
        </template>
        <template v-else-if="header.value === 'affiliate_manager_id'">
          {{item.affiliate_manager_name}}
        </template>
        <template v-else-if="isEntityName(header.value)">
          <a class="entity-link" @click="showCard(item)">{{item[header.value]}}</a>
        </template>
        <template v-else><short-text :text="item[header.value]"></short-text></template>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pt-0 px-1 pb-1">
          <div style="background-color: #fff">
          <v-tabs v-if="detailTab[item.id] !== undefined" v-model="detailTab[item.id]" height="40">
            <v-tab :key="`breakdown-${item.id}`">
              Breakdown
            </v-tab>
            <v-tab :key="`history-${item.id}`">
              History
            </v-tab>
            <v-tab :key="`items-${item.id}`">
              Items
            </v-tab>
            <v-tab :key="`paymentDetails-${item.id}`">
              Payment Details
            </v-tab>
            <v-tab :key="`affiliateEmail-${item.id}`">
              Affiliate Email
            </v-tab>
          </v-tabs>
          <v-tabs-items v-if="detailTab[item.id] !== undefined" v-model="detailTab[item.id]">
            <v-tab-item :key="`breakdown-${item.id}`">
              <PaymentAmount :payment="item"/>
            </v-tab-item>
            <v-tab-item :key="`history-${item.id}`">
              <v-simple-table v-if="item.history && item.history.length" dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>At</th>
                      <th>Entity</th>
                      <th>Action</th>
                      <th>Field</th>
                      <th>From</th>
                      <th>To</th>
                      <th>By</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(ph, index) in item.history" :key="`history-${item.id}-${index}`">
                      <td>{{ph.date_added}}</td>
                      <td>{{ph.entity}}</td>
                      <td>{{ph.action}}</td>
                      <td>{{ph.field_name}}</td>
                      <td>{{ph.from_value}}</td>
                      <td>{{ph.to_value}}</td>
                      <td>{{ph.initiator}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <p class="v-subheader h3" v-else>
                There is no history yet.
              </p>
            </v-tab-item>
            <v-tab-item :key="`items-${item.id}`">
              <PaymentItems :payment="item"/>
            </v-tab-item>
            <v-tab-item :key="`paymentDetails-${item.id}`">
              <PaymentDetails :payment="item"/>
            </v-tab-item>
            <v-tab-item :key="`affiliateEmail-${item.id}`">
              <template>
                <tr>
                  <td class="text-capitalize">{{item.affiliate.email}}</td>
                </tr>
              </template>
            </v-tab-item>
          </v-tabs-items>
          </div>
        </td>
      </template>
      <!-- body -->
    </v-data-table>
    <DataTableBottomBar
        :showFilter="Object.values(table.filters).find(f => f.selected.length) !== undefined"
        @clearFilters="removeAllFilters"
        v-model="table.heightCounter"
    ></DataTableBottomBar>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="400"
    >
      <v-card>
        <v-card-title class="text-h6">
          {{dialogTitle}}
        </v-card-title>
        <v-card-text>{{dialogText}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
              color="primary"
              text
              @click="updatePayment"
              :loading="dialogLoading"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <PdfContent ref="pdf" :key="`pdf-${currentItem.id || 0}`" :payment="currentItem"
                :payment-items="paymentItems"
                :payment-details="paymentDetails"
                :payment-history="paymentHistory"
    />
    <UploadCSVModal :dialog.sync = "isUploadCSVModalVisible" @csvUploaded="csvUploadedData"/>
    <PaymentConfirmationModal
            v-model="showModal"
            :payments="selectedRows"
            :key="dialogKey"
            @confirm="handleConfirm"
    />
    <div v-if="isLoading" class="overlay">
      <v-progress-circular
              indeterminate
              size="64"
              color="primary"
      />
    </div>
  </div>
</template>

<script>
import DataTableTopBar from '@/components/common/DataTableTopBar';
import DataTableBottomBar from '@/components/common/DataTableBottomBar';
import store from '@/store';
import { DateTime } from 'luxon';
import {mapGetters} from "vuex";
import paymentsApi from '@/api/payments';
import PdfContent from "@/components/common/PdfContent";
import UploadCSVModal from "@/components/common/UploadCSVModal";
import PaymentConfirmationModal from "@/components/common/PaymentConfirmationModal";
import PaymentItems from "@/components/pages/payments/PaymentItems";
import PaymentDetails from "@/components/pages/payments/PaymentDetails";
import PaymentAmount from "@/components/pages/payments/PaymentAmount";
import VueJsonToCsv from 'vue-json-to-csv';
import JSZip from 'jszip';

export default {
  props: {
    showActions: {
      default: true
    },
    hideUnrelated: {
      default: false
    }
  },
  data() {
    return {
      sheet: false,
      showModal: false,
      isTipaltiHasRecords: false,
      tipaltiAmount: 0,
      restSumAmount: 0,
      isPayoneerHasRecords: false,
      isBitcoinHasRecords: false,
      expanded: [],
      selectedRows: [],
      isAllToggle: false,
      isLoading: false,
      detailTab: {},
      isUploadCSVModalVisible: false,
      tabsMap: {
        'items': 0,
        'details': 1,
        'history': 2
      },
      byStatus: '',
      currentStatus: '',
      dialog: false,
      dialogKey: 1,
      dialogTitle: '',
      dialogText: '',
      dialogLoading: false,
      currentItem: {},
      action: '',
      pdfFilename: 'invoice',
      invoicePayment: {},
      paymentItems: [],
      paymentDetails: [],
      paymentHistory: {},
      invoiceLoading: {},
      table: {
        heightCounter: 45,
        loading: false,
        searchInAffiliates: '',
        awaitingSearch: false,
        currentPage: 1,
        perPage: 25,
        pageChangedByMe: false,
        pageOptions: [10, 25, 50, 100, 500, 1000],
        orderBy: '',
        sortColumnsAsc: true,
        headers: [
          { text: 'Payment ID', value: 'id', align: 'center' }, //
          { text: 'Aff Id', value: 'affiliate_id', align: 'center' }, //
          { text: 'Aff Name', value: 'affiliate_name', class: 'color', align: 'center' }, //
          { text: 'Aff Status', value: 'affiliate_status', class: 'color', align: 'center' }, //
          { text: 'Affiliate Manager', value: 'affiliate_manager_id', class: 'color', align: 'center' }, //
          { text: 'Period', value: 'period', align: 'center' }, //
          { text: 'Payment Terms', value: 'payment_terms', align: 'center' }, //
          { text: 'Billing Cycle', value: 'billing_cycle', align: 'center' }, //
          { text: 'Payment Type', value: 'payment_type', align: 'center' }, //
          { text: 'Currency', value: 'currency', align: 'center' }, //
          { text: 'Total', value: 'total', align: 'center' }, //
          { text: 'Paid', value: 'paid', align: 'center', sortable: false }, //
          { text: 'Balance', value: 'balance', align: 'center', sortable: false }, //
          { text: 'Actions', value: 'actions', align: 'center', sortable: false}
        ],
        filters: {
          affiliate_id: {selected: [], data: []},
          affiliate_name: {selected: [], data: []},
          affiliate_status: {selected: [], data: []},
          affiliate_manager_id: {selected: [], data: []},
          status: {selected: [], data: []},
          period: {selected: [], data: []},
          payment_terms: {selected: [], data: []},
          payment_type: {selected: [], data: []},
          currency: {selected: [], data: []},
          billing_cycle: {selected: [], data: []},
          amount: {selected: [], data: []},
          dateAdded: {selected: [], data: []},
        }
      },
      filtersMenu: false,
      isDownloading: false
    }
  },

  async mounted() {
    this.byStatus = this.$route.path;
    if (!this.showActions) {
      const actionsIndex = this.table.headers.findIndex(h => h.value === 'actions');
      if (actionsIndex > -1) {
        this.table.headers.splice(actionsIndex, 1)
      }
    }
    await this.getTableData()
    this.getFiltersData()
  },

  methods: {
    uploadCSV() {
      this.isUploadCSVModalVisible = true;
    },
    async csvUploadedData(data) {
      const tipaltiHeaders = ['Id', 'Amount submitted', 'Payment method', 'Status'];
      const payoneerHeaders = ['Payee ID'];
      try {
        const { fields } = data;
        if (data.type.toLowerCase() === 'tipalti' && !this.validateCSV(tipaltiHeaders, fields)) {
          return this.csvUploaderHandleError(`Incorrect CSV structure`);
        }
        if (data.type.toLowerCase() === 'payoneer' && !this.validateCSV(payoneerHeaders, fields)) {
          return this.csvUploaderHandleError(`Incorrect CSV structure`);
        }
        this.isUploadCSVModalVisible = false;
        const result = await paymentsApi.uploadCSVData({method: data.type, rows: data.data});
        if ((result || result === 0) && result >= 0) {
          this.csvUploaderHandleSuccess(`${result} payment(s) closed`)
        }
        await this.getTableData();
      } catch (e) {
        this.csvUploaderHandleError();
      }
    },
    validateCSV(expectHeaders, actualHeaders) {
      let result = true;
      expectHeaders.forEach(expectedHeader => {
        if (!actualHeaders.includes(expectedHeader)) {
          return result = false;
        }
      });
      return result;
    },
    createCSVTipalti() {
      if (!this.isTipaltiHasRecords){
        alert('no records for Tipalti');
        return;
      }
      this.$refs.tipaltiButton.click();
    },
    createCSVRest() {
      if (!this.isPayoneerHasRecords && !this.isBitcoinHasRecords){
        alert('no records for Payoneer and Bitcoin');
        return;
      }

      if (this.isPayoneerHasRecords){
        this.$refs.payoneerButton.click();
      }
      if (this.isBitcoinHasRecords){
        this.$refs.bitcoinButton.click();
      }

    },
    csvUploaderHandleSuccess(message = 'Csv file upload successfully'){
      store.dispatch('alert/ALERT_SUCCESS', message);
      setTimeout(() => {store.dispatch('alert/ALERT_REMOVE')}, 3000);
    },
    csvUploaderHandleError(message = 'Csv file upload with errors.'){
      store.dispatch('alert/ALERT_ERROR', message);
    },
    paymentDetailsByMethod(details, paymentType){
       return details.filter(detail => detail.paymentType === paymentType);
    },
    paymentDetailsByType(details, paymentType) {
      const type = [];
      type.push(paymentType);

      const result = this.filterDataByPaymentType(details, type);
      let sumAmount = result.reduce((acc, item) => acc + item.amount, 0);

      if (paymentType === 'Payoneer') {
        this.isPayoneerHasRecords = result.length > 0;
      } else if (paymentType === 'Bitcoin') {
        this.isBitcoinHasRecords = result.length > 0;
      }

      if (this.isPayoneerHasRecords && paymentType !== 'Payoneer') {
        const payoneerResult = this.filterDataByPaymentType(details, ['Payoneer']);
        sumAmount += payoneerResult.reduce((acc, item) => acc + item.amount, 0);
      }

      if (this.isBitcoinHasRecords && paymentType !== 'Bitcoin') {
        const bitcoinResult = this.filterDataByPaymentType(details, ['Bitcoin']);
        sumAmount += bitcoinResult.reduce((acc, item) => acc + item.amount, 0);
      }
      this.restSumAmount = sumAmount;
      return result || [];
    },
    paymentDetailsTipalti(details){
      const tipaltiPayments = ["WireTransfer", "PayPal", "ACH", "eCheck", "Check"];
      const tipaltiResult = this.filterDataByPaymentType(details,tipaltiPayments);
      this.isTipaltiHasRecords = tipaltiResult.length > 0;
      this.tipaltiAmount = tipaltiResult.reduce((acc, item) => acc + item.amount, 0);
      return tipaltiResult || [];
    },
    filterDataByPaymentType(data, paymentTypes){
      const filteredDetails = [];

      data.forEach(item => {
        if (item.paymentType && paymentTypes.includes(item.paymentType)) {
          const filteredItemDetails = item.details.filter(detail => paymentTypes.includes(detail.paymentType));
          filteredDetails.push(...filteredItemDetails);
        }
      });

      return filteredDetails;
    },
    expandItem(item, tab) {
      const index = this.expanded.findIndex((exp) => exp.id === item.id);
      if (index > -1) {
        if (this.detailTab[item.id] !== this.tabsMap[tab]) {
          this.detailTab[item.id] = this.tabsMap[tab]
        } else {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded.push(item);
        const newItem = {};
        newItem[item.id] = this.tabsMap[tab];
        this.detailTab = {...this.detailTab, ...newItem};
      }
    },
    itemExpandedHandler({item, value}) {
      if (this.detailTab[item.id] === undefined) {
        const newItem = {};
        newItem[item.id] = this.tabsMap.items;
        this.detailTab = {...this.detailTab, ...newItem};
      }
    },
    getDate(add = undefined) {
      const today = DateTime.fromISO(this.currentItem.end_period, { zone: 'UTC' });
      if (add) {
        return today.plus({days:add}).toFormat('DDD');
      }
      return today.toFormat('DDD');
    },
    approveHandler(item) {
      this.dialogTitle = 'Approve payment?'
      this.dialogText = `Are you sure you want to approve $${item.amount} payment?`;
      this.currentItem = item;
      this.action = 'approve';
      this.dialog = true;
    },
    async updatePayment() {
      if (this.dialogLoading) {
        return;
      }
      this.dialogLoading = true;
      await store.dispatch('payments/updatePayment', {
        paymentId: this.currentItem.id,
        action: this.action,
      });
      this.dialogLoading = false;
      this.dialog = false;
      this.dialogTitle = ''
      this.dialogText = ``;
      this.currentItem = {};
      this.action = '';
    },
    paidHandler(item) {
      this.selectedRows = [item];
      this.dialogKey += 1;
      this.showModal = true;
    },
    async invoiceHandler(item) {
      // show preloader
      this.invoiceLoading[item.id] = true;
      this.pdfFilename = `invoice_${item.start_period}-${item.start_period}_${Math.random() * 1000000}`;
      this.currentItem = item;
      // get payment items by payment id
      const paymnentItems = await paymentsApi.getPaymentItems({paymentId: item.id});
      const paymentModifications = await paymentsApi.getPaymentModifications({paymentId: item.id});
      if (paymentModifications) {
        paymentModifications.forEach((modification) => {
          paymnentItems.push({
            id: `pm${modification.id}`,
            itemName: modification.note,
            count: 1,
            itemCurrency: modification.item_currency,
            currencyRate: modification.currency_rate,
            amount: modification.amount,
            sumAmount: (modification.amount * modification.currency_rate),
          });
        });
      }
      this.paymentItems = paymnentItems;
      [this.paymentDetails, this.paymentHistory] = await Promise.all([
          paymentsApi.getPaymentDetails({paymentId: item.id}),
          paymentsApi.getPaymentHistory({paymentId: item.id})
      ]);

      this.invoiceLoading[item.id] = false;

      await this.$nextTick();

      this.$refs.pdf.downloadInvoice();
      // hide preloader
      this.invoiceLoading[item.id] = false;
    },
    editHandler(item) {
      store.dispatch('cards/ADD', {
        type: 'payment',
        title: item.affiliateNameId,
        key: `payment-${item.id}`,
        data: item
      })
    },
    async undoHandler(item) {
      try {
        this.dialogTitle = 'Revert Payment?';
        this.dialogText = `Are you sure you want to revert this $${item.amount} payment to approved status?`;
        this.currentItem = item;
        this.action = 'approve';
        this.dialog = true;
      } catch (e) {
        store.dispatch('alert/ALERT_ERROR', `An error has occurred.`);
        this.table.loading = false;
      }
    },
    carryOverHandler(item) {
      if (this.dialog || this.dialogLoading) {
        return;
      }
      this.dialogTitle = 'Carry Over payment?'
      this.dialogText = `Are you sure you want to carry over $${item.amount} payment?`;
      this.currentItem = item;
      this.action = 'carry_over';
      this.dialog = true;
    },
    reviewHandler(item) {
      this.dialogTitle = 'Review payment?'
      this.dialogText = `Are you sure you want to send $${item.amount} payment to review?`;
      this.currentItem = item;
      this.action = 'review';
      this.dialog = true;
    },
    getPeriod(start, end) {
      if (!start || !end) {
        return '';
      }
      const startDate = DateTime.fromISO(start, { zone: 'UTC' });
      const endDate = DateTime.fromISO(end, { zone: 'UTC' });
      if (!startDate || !endDate) {
        return '';
      }
      return `${startDate.toFormat('LLL dd')} - ${endDate.toFormat('DD')}`
    },
    getPrettyDate(date) {
      return DateTime.fromISO(date).toFormat('MMMM dd, yyyy');
    },
    isEntityName(item) {
      return ['affNameId'].includes(item)
    },
    showCard(item) {
      store.dispatch('cards/ADD', {
        type: 'affiliate',
        title: item.name,
        key: `affiliate-${item.id}`,
        data: item
      })
    },
    getFiltersData() {
      const filters = {};
      const pathArray = this.$route.path.split('/');
      if (pathArray[2]) {
        filters.status = [pathArray[2].replaceAll('-', '_')];
      }
      for(const name in this.table.filters) {
        paymentsApi.getFilter({
          filter: filters,
          name: name,
        }).then(res => {
          this.table.filters[name].data = res;
        });
      }
    },
    async getTableData() {
      this.table.loading = true
      this.activateFilters()
      const filters = await this.getFilters();
      await store.dispatch('payments/getPayments', {
          orderBy: this.table.orderBy,
          orderDirectionAsc: this.table.sortColumnsAsc,
          page: this.table.currentPage,
          limit: this.table.perPage,
          filters: filters || null,
      });
      await store.dispatch('payments/getPaymentsCalculations', {
        filters: filters || null
      });
      this.table.loading = false
    },
    /** todo add to helper */
    addParamsToLocation(params) {
      const query = JSON.stringify(params) === '{}' ? this.$route.path :
          this.$route.path + '?' + Object.keys(params).map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
          ).join('&')
      history.pushState({},null, query);
    },
    updateFiltersFromQuery() {
      const queryFilters = JSON.parse(this.$route.query.filters);
      for(const name in this.table.filters) {
        if(queryFilters[name]) {
          this.table.filters[name].selected = queryFilters[name];
        }
      }
    },
    async getFilters() {
      const filters = {};
      if (this.table.searchInAffiliates.length > 0) {
        filters['search'] = this.table.searchInAffiliates;
      }
      const pathArray = this.$route.path.split('/');
      if (pathArray[2]) {
        filters.status = [pathArray[2].replaceAll('-', '_')];
      }
      this.currentStatus = filters.status
      for(const name in this.table.filters) {
        if (this.table.filters[name].selected.length > 0) {
          filters[name] = this.table.filters[name].selected;
        }
      }
      // Hide Blacklisted from all tabs except Closed/Carried-Over
      if (!['closed', 'carried-over'].includes(pathArray[2])) {
        if (!filters.affiliate_status) {
          filters.affiliate_status = ['active', 'suspended', 'blocked'];
        } else {
          filters.affiliate_status = filters.affiliate_status.filter(status => status !== 'blacklisted');
        }

      }
      return filters;
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1;
      this.table.pageChangedByMe = true;
      if(data && entity) {
        this.table.filters[entity].selected = data;
      }
      return await this.getTableData()
    },
    activateFilters() {
      const filtersForQuery = {};
      for (const name in this.table.filters) {
        if(this.table.filters[name].selected.length > 0) {
          filtersForQuery[name] = this.table.filters[name].selected;
        }
      }
      this.addParamsToLocation(
          JSON.stringify(filtersForQuery) !== '{}' ? {filters: JSON.stringify(filtersForQuery)} : {}
      );
    },
    async updateDataInFilters(data, modalName) {
      if(modalName) {
        const filters = {};
        const pathArray = this.$route.path.split('/');
        if (pathArray[2]) {
          filters.status = [pathArray[2].replaceAll('-', '_')];
        }
        paymentsApi.getFilter({
          filter: filters,
          name: modalName,
          searchFilter: data
        }).then(res => {
          this.table.filters[modalName].data = res;
        });
      }
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = column
      await this.getTableData()
    },
    updateTablePagination(params){
      if (
          (this.table.currentPage === params.page &&
              this.table.perPage === params.itemsPerPage) ||
          this.table.pageChangedByMe
      ) {
        this.table.pageChangedByMe = false;
        return
      }
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      if(this.$route.query.filters) {
        this.updateFiltersFromQuery();
      }
      this.getTableData();
    },
    openDialog(item) {
      this.dialog.item = item;
      this.dialog.title = `Edit ${item.affNameId}'s profile`
      this.dialog.open = true;
    },
    async handleConfirm(payments) {
      this.selectedRows = [];
      console.log('Confirmed payments:', payments);
      await paymentsApi.partialPayPayments(payments);
      await this.getTableData();
    },
    search(value) {
      this.table.searchInAffiliates = value
      this.submitFilter();
    },
    async removeAllFilters() {
      for (let key in this.table.filters) {
        this.table.filters[key].selected = [];
      }
      await this.getTableData()
    },
    onSelect($event) {
      this.$emit('selected', $event)
    },
    async downloadHandler(ids) {

      const filesData = await paymentsApi.download(ids.map(id => Number(id)));

      const zip = new JSZip();

      if(!filesData.files.length) {
        return;
      }

      filesData.files.forEach(file => {
        zip.file(`payment-${file.payment_id}.pdf`, window.atob(file.content), { binary: true});
      });

      zip.generateAsync({type:"blob"}).then(function(content) {
        const blob = new Blob([content], {type: 'application/zip'});
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'payments.zip');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedRows = [];
      } else {
        this.selectedRows = [...this.payments.data];
      }
    },
    async massAction(action) {
      try {
        this.isLoading = true;
        const paymentIds = [...new Set(this.selectedRows.map( payment => payment.id))];

        if (action === 'download') {
          if (paymentIds.length > 3) {
            store.dispatch('alert/ALERT_ERROR', `Please pick less then 4 items`);
            return;
          }
          this.isDownloading = true;
          await this.downloadHandler(paymentIds);
          this.isDownloading = false;
          return;
        }

        const mapStatusAction = {
          approve: 'approved',
          carry_over: 'carried_over',
          pay: 'closed',
          close: 'rejected'
        }

        if (action === 'pay') {
          this.dialogKey += 1;
          this.showModal = true;
          return;
        }

        await store.dispatch('payments/massUpdatePayments', {
          paymentIds: paymentIds,
          action: mapStatusAction[action],
        });

        store.dispatch('alert/ALERT_SUCCESS', `${paymentIds.length} Payments sent for update.`, {root: true});
        await this.getTableData();
      } catch (e) {
        store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
      } finally {
        this.isLoading = false;
      }

      this.selectedRows = [];

      setTimeout(() => {
        store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
      }, 3000);

    },
    
    async exportPayments() {
      try {
        const paymentIds = this.selectedRows.map(payment => payment.id);
        
        if (paymentIds.length === 0) {
          store.dispatch('alert/ALERT_ERROR', 'Please select at least one payment');
          return;
        }

        this.isLoading = true;
        
        const response = await paymentsApi.exportPayments({ paymentIds });
        
        // Check if we received CSV data for direct download (< 10k payments)
        if (response.csvContent && response.filename) {
          // Create blob and download file
          const blob = new Blob([response.csvContent], { 
            type: 'text/csv;charset=utf-8;' 
          });
          
          const link = document.createElement('a');
          const url = URL.createObjectURL(blob);
          link.href = url;
          link.download = response.filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          
          store.dispatch('alert/ALERT_SUCCESS', response.message, { root: true });
          console.log('Export downloaded:', response.filename);
        } else {
          // Large export - email only
          store.dispatch('alert/ALERT_SUCCESS', response.message, { root: true });
          console.log('Export response:', response);
        }
        
      } catch (error) {
        console.error('Export error:', error);
        store.dispatch('alert/ALERT_ERROR', 'Failed to export payments. Please try again.', { root: true });
      } finally {
        this.isLoading = false;
        
        setTimeout(() => {
          store.dispatch('alert/ALERT_REMOVE', '', { root: true });
        }, 7000);
      }
  }
  },

  computed: {
    ...mapGetters('payments', ['payments','paymentsCalculations', 'updatedPaymentsCount']),
    currentTab(){
      const pathArray = this.$route.path.split('/');
      if (pathArray[2]) {
       return pathArray[2].replaceAll('-', '_');
      }
      return 'active';
    },
    allSelected() {
      return this.selectedRows.length === this.payments.data.length;
    },
    isMassBtnDisabled(){
      return this.selectedRows.length === 0;
    },
    isShowSelect() {
      return ['pending', 'approved', 'closed', 'active', 'carried_over'].includes(this.currentTab);
    }
  },

  components: {
    VueJsonToCsv,
    PaymentItems,
    PaymentDetails,
    PaymentAmount,
    DataTableTopBar,
    DataTableBottomBar,
    PdfContent,
    UploadCSVModal,
    PaymentConfirmationModal
  },
}
</script>

<style lang="sass">
.co-data-table
  .v-data-table__wrapper
    .v-data-table-header
      th
        white-space: nowrap
.search_btn_wrap
  h1
    margin-bottom: 0
  .search_wrapper
    width: 250px
    padding-bottom: 15px

.text-right
  text-align: right

.overlay
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(128, 128, 128, 0.4)
  display: flex
  justify-content: center
  align-items: center
  z-index: 9999

</style>
